import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Replace these with your Firebase project credentials
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // Prefer explicit DATABASE_URL, otherwise construct from PROJECT_ID
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    (process.env.REACT_APP_FIREBASE_PROJECT_ID
      ? `https://${process.env.REACT_APP_FIREBASE_PROJECT_ID}-default-rtdb.firebaseio.com`
      : undefined),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (!firebaseConfig.databaseURL && !firebaseConfig.projectId) {
  // Defensive: give a clearer error in dev if both values are missing
  // eslint-disable-next-line no-console
  console.error(
    'FIREBASE CONFIG ERROR: missing databaseURL and projectId in firebaseConfig.'
  );
}

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
